import React, { Component, ReactElement } from 'react';
import { FlexibleModal } from './flexible-modal';

type ModalState = {
  promiseInfo: any;
  show: boolean;
};

type SubmitModalProps = {
  title: string;
  confirmButtonMessage?: string;
  cancelButtonMessage?: string;
  disabledSubmit?: boolean;
  children?: ReactElement<any>;
};

export default class SubmitFormModal extends Component<SubmitModalProps, ModalState> {
  constructor(props: any) {
    super(props);
    this.state = {
      show: false,
      promiseInfo: {},
    };
  }

  show = async () => {
    return new Promise((resolve, reject) => {
      this.setState({
        promiseInfo: {
          resolve,
          reject,
        },
        show: true,
      });
    });
  };

  hide = () => {
    this.setState({
      show: false,
    });
  };

  render() {
    const { show } = this.state;
    const { resolve, reject } = this.state.promiseInfo;
    return (
      <FlexibleModal
        show={show}
        title={this.props.title}
        confirmButtonMessage={this.props.confirmButtonMessage}
        cancelButtonMessage={this.props.cancelButtonMessage}
        disabledSubmit={this.props.disabledSubmit}
        onConfirm={() => {
          this.hide();
          resolve();
        }}
        onCancel={() => {
          this.hide();
          reject();
        }}
      >
        <>{this.props.children}</>
      </FlexibleModal>
    );
  }
}
